import { PersistenceStateUsingContext } from "@/shared/persistence-state/persistence-state-info";
import {
  ArtefactPage,
  ArtefactPageActions,
  ArtefactPageContent,
  ArtefactPageHeader,
  ArtefactPageNavigation,
  ArtefactPageNavigationLink,
  ArtefactPageNavigationOutlet,
} from "@/shared/service-manager/default-ui/artefact-page/artefact-page";
import { useParams } from "react-router";
import CreateInspectionButton from "./differentiation/_components/create-inspection-button";
import { useShowDifferentiationQuery } from "@/services/backend/differentiation/service";
import { ArtefactNotReadyAlert } from "@/shared/service-manager/artefact/artefact-sheet";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";

export function DifferentiationRoute() {
  const { processId, differentiationId } = useParams();
  const { data: diff } = useShowDifferentiationQuery({
    id: differentiationId!,
  });
  const immutable = !!diff?.differentiation.immutable;
  const { notReadyError } = useErrArtefactNotReady();
  const links = [
    {
      to: "differentiation",
      label: "Differenzierung",
    },
    {
      to: "counting",
      label: "Zählung",
    },
  ];

  return (
    <ArtefactPage>
      <ArtefactPageHeader>
        <ArtefactPageNavigation>
          {links.map((link) => (
            <ArtefactPageNavigationLink to={link.to} key={link.to}>
              {link.label}
            </ArtefactPageNavigationLink>
          ))}
        </ArtefactPageNavigation>
        <ArtefactPageActions>
          <PersistenceStateUsingContext className="mr-2" />
          {!immutable && (
            <CreateInspectionButton
              processId={processId!}
              differentiationId={differentiationId!}
            />
          )}
        </ArtefactPageActions>
      </ArtefactPageHeader>
      <ArtefactPageContent>
        <ArtefactNotReadyAlert
          error={notReadyError}
          artefact="Differentiation"
        />
        <ArtefactPageNavigationOutlet />
      </ArtefactPageContent>
    </ArtefactPage>
  );
}
